import { Header, Container, Group, Burger, rem, createStyles, Image } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { useAuth } from '../hooks/useAuth';
import { ProfileMenu } from './ProfileMenu';
import { Link } from 'react-router-dom';
import betfolioLogo from '../assets/betfolio-logo-gfx-orig.png';

const useStyles = createStyles((theme) => ({
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '100%',
  },

  links: {
    [theme.fn.smallerThan('sm')]: {
      display: 'none',
    },
  },

  burger: {
    [theme.fn.largerThan('sm')]: {
      display: 'none',
    },
  },

  mobileMenu: {
    display: 'none',
    [theme.fn.smallerThan('sm')]: {
      display: 'block',
      position: 'absolute',
      top: '60px',
      left: 0,
      right: 0,
      backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[7] : theme.white,
      padding: theme.spacing.md,
      borderTop: `1px solid ${theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors.gray[2]}`,
      zIndex: 1000,
    },
  },

  mobileMenuHidden: {
    display: 'none',
  },

  link: {
    display: 'block',
    lineHeight: 1,
    padding: `${rem(8)} ${rem(12)}`,
    borderRadius: rem(6),
    textDecoration: 'none',
    color: theme.colorScheme === 'dark' ? theme.colors.dark[0] : theme.colors.gray[7],
    fontSize: theme.fontSizes.sm,
    fontWeight: 500,

    '&:hover': {
      backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.colors.gray[0],
    },
  },

  linkLabel: {
    marginRight: rem(5),
  },
}));

interface HeaderSearchProps {
  links: { link: string; label: string }[];
}

export function AppHeader({ links }: HeaderSearchProps) {
  const [opened, { toggle }] = useDisclosure(false);
  const { user } = useAuth();
  const { classes } = useStyles();

  const items = links.map((link) => (
    <Link
      key={link.label}
      to={link.link}
      className={classes.link}
    >
      {link.label}
    </Link>
  ));

  return (
    <Header height={60} mb={120}>
      <Container className={classes.header}>
        <Link to="/" style={{ textDecoration: 'none', color: 'inherit' }}>
          <Group spacing="sm">
            <Image src={betfolioLogo} alt="Betfolio Logo" width={30} height={30} />
            <h2 style={{ margin: 0 }}>Betfolio</h2>
          </Group>
        </Link>
        <Group spacing={5} className={classes.links}>
          {items}
        </Group>
        {user && <ProfileMenu user={user} />}
        <Burger
          opened={opened}
          onClick={toggle}
          className={classes.burger}
          size="sm"
        />
      </Container>
      <div className={`${classes.mobileMenu} ${!opened ? classes.mobileMenuHidden : ''}`}>
        {items}
      </div>
    </Header>
  );
}